const en_sales_recap = {
    "": "sales billing recap",
    add: "add sales billing recap",
    detail: "sales billing recap details",

    label: {
        no_recap: "billing recap No.",
        inv_choose: "select invoice",
        inv_selected: "selected invoices:",
    },

    message: {
        cancel_title: "Are you sure you want to cancel the billing recap?",
        cancel_text: "Enter the reason for cancelling the billing recap",
    },

    error: {
        create: "Failed to create sales billing recap.",
        edit: "Failed to update sales billing recap.",
        cancel: "Failed to cancel billing recap",
    },

    success: {
        create: "Sales billing recap created successfully.",
        edit: "Sales billing recap updated successfully.",
        cancel: "Billing recap cancelled successfully",
    },
}

export default en_sales_recap;